import type { FunctionComponent } from 'react';

import { ListTestIds } from '@trello/test-ids';

import styles from './ListColorPickerSkeleton.less';

export const ListColorPickerSkeleton: FunctionComponent = () => {
  return (
    <div data-testid={ListTestIds.ListColorPickerSkeleton}>
      <div className={styles.row} />
      <div className={styles.row} />
      <div className={styles.removeColorButton} />
    </div>
  );
};
